import * as utils from "../misc/utils.js";


export function createYears(chart, element, url) {
    utils.loadJSONP(url, true).then((years) => {


        let selectElement = element.appendChild(document.createElement("select"));
        selectElement.id = 'selectedyear';
        selectElement.className = 'skr-select';
        selectElement.setAttribute("role", "listbox");
        for (let i = 0; i < years.rows.length; i++) {
            let option = document.createElement('option');
            option.text = years.rows[i][1];
            option.value = years.rows[i][0];
            option.setAttribute("role", "option");
            selectElement.add(option);
        }
        chart.year = selectElement.value;
        selectElement.addEventListener("change", () => {
            chart.year = selectElement.value
        });
    });
}

export function create70ServicesList(chart, element) {
    let url = "https://signe.vantetider.se/seam/resource/rest/70SVFServices";
    utils.loadJSONP(url, true).then((treatmentCode) => {
        let svfSelectElement = element.appendChild(document.createElement("select"));
        let option = document.createElement('option');
        option.text = "Alla vårdförlopp";
        option.value = '';
        option.setAttribute("role", "option");
        svfSelectElement.add(option);
        svfSelectElement.id = 'selectedtreatment'
        svfSelectElement.className = 'skr-select';
        svfSelectElement.setAttribute("role", "listbox");
        for (let i = 0; i < treatmentCode.rows.length; i++) {
            option = document.createElement('option');
            option.setAttribute("role", "option");
            option.text = treatmentCode.rows[i][1];
            option.value = treatmentCode.rows[i][0];
            svfSelectElement.add(option);
        }

        chart.service = svfSelectElement.value;
        svfSelectElement.addEventListener("change", () => {
            if (svfSelectElement.value == '') {
                chart.service = '';
            } else {
                chart.service = svfSelectElement.value;
            }
        });

    });
}
export function createTreatmentList(chart, element) {
    let url = "https://signe.vantetider.se/seam/resource/rest/commonTreatmentCodes"

    utils.loadJSONP(url, true).then((treatmentCode) => {
        let treatmentSelectElement = element.appendChild(document.createElement("select"));
        let option = document.createElement('option');
        option.text = "Alla behandlingar";
        option.value = '';
        option.setAttribute("role", "option");
        treatmentSelectElement.add(option);
        treatmentSelectElement.id = 'selectedtreatment'
        treatmentSelectElement.className = 'skr-select';
        treatmentSelectElement.setAttribute("role", "listbox");
        for (let i = 0; i < treatmentCode.rows.length; i++) {
            option = document.createElement('option');
            option.setAttribute("role", "option");
            option.text = treatmentCode.rows[i].name;
            option.value = treatmentCode.rows[i].code;
            treatmentSelectElement.add(option);
        }


        treatmentSelectElement.addEventListener("change", () => {
            if (treatmentSelectElement.value == '') {
                chart.treatmentcode = '';
            } else {
                chart.treatmentcode = treatmentSelectElement.value;
            }
        });
    });
}
export function createSVFAndTreatment(chart, svfElement, treatmentElement) {
    utils.loadJSONP("https://signe.vantetider.se/seam/resource/rest/selectableSVFServices", true).then((svf) => {
        utils.loadJSONP("https://signe.vantetider.se/seam/resource/rest/svfAndTreatmentCodes", true).then((treatmentCode) => {
            utils.loadJSONP("https://signe.vantetider.se/seam/resource/rest/commonTreatmentCodes", true).then((commonCodes) => {

            let svfSelectElement = svfElement.appendChild(document.createElement("select"));
            svfSelectElement.id = 'selectedsvf';
            svfSelectElement.className = 'skr-select';
            svfSelectElement.setAttribute("role", "listbox");
            let option = document.createElement('option');
            option.text = "Alla vårdförlopp";
            option.value = "";
            option.setAttribute("role", "option");
            svfSelectElement.add(option);
            for (var i = 0; i < svf.rows.length; i++) {
                option = document.createElement('option');
                option.text = svf.rows[i][1];
                option.value = svf.rows[i][0];
                option.setAttribute("role", "option");
                svfSelectElement.add(option);
            }

            let treatmentSelectElement = treatmentElement.appendChild(document.createElement("select"));
            option = document.createElement('option');
            option.text = "Alla behandlingar";
            option.value = '';
            option.setAttribute("role", "option");
            treatmentSelectElement.add(option);
            treatmentSelectElement.id = 'selectectreatment';
            treatmentSelectElement.className = 'skr-select';
            treatmentSelectElement.setAttribute("role", "listbox");
            for (let i = 0; i < commonCodes.rows.length; i++) {
                option = document.createElement('option');
                option.text = commonCodes.rows[i].name;
                option.value = commonCodes.rows[i].code;
                option.setAttribute("role", "option");
                treatmentSelectElement.add(option);
            }

            svfSelectElement.addEventListener("change", () => {
                treatmentSelectElement.options.length = 0;
                option = document.createElement('option');
                option.text = "Alla behandlingar";
                option.value = '';
                option.setAttribute("role", "option");
                treatmentSelectElement.add(option);
                if (svfSelectElement.value == '') {
                    chart.service = '';
                    for (let i = 0; i < commonCodes.rows.length; i++) {
                        option = document.createElement('option');
                        option.text = commonCodes.rows[i].name;
                        option.value = commonCodes.rows[i].code;
                        option.setAttribute("role", "option");
                        treatmentSelectElement.add(option);
                    }
                } else {
                    chart.service = svfSelectElement.value;
                    
                    for (var i = 0; i < treatmentCode.length; i++) {
                        if (treatmentCode[i].id == svfSelectElement.value) {
                            for (var j = 0; j < treatmentCode[i].codes.length; j++) {
                                option = document.createElement('option');
                                option.text = treatmentCode[i].codes[j].name;
                                option.value = treatmentCode[i].codes[j].code;
                                option.setAttribute("role", "option");
                                treatmentSelectElement.add(option);

                            }
                            break;
                        }
                    }
                }
                
                
            });
            treatmentSelectElement.addEventListener("change", () => {
                if (treatmentSelectElement.value == '') {
                    chart.treatmentcode = '';
                } else {
                    chart.treatmentcode = treatmentSelectElement.value;

                }
            });

        });
    });
});


}
export function createRCCAndRegions(chart, element) {
    utils.loadJSONP("https://signe.vantetider.se/seam/resource/rest/selectableCentres", true).then((centres) => {
        utils.loadJSONP("https://signe.vantetider.se/seam/resource/rest/selectableRegions", true).then((regions) => {

            var optionList = [];
            for (var i = 0; i < centres.rows.length; i += 1) {
                var testObj = {};
                testObj.centreName = centres.rows[i][1];
                testObj.centreId = centres.rows[i][0];
                testObj.regions = [];
                for (var j = 0; j < regions.rows.length; j += 1) {
                    if (centres.rows[i][0] === regions.rows[j][2]) {
                        testObj.regions.push(regions.rows[j]);
                    }
                }
                optionList.push(testObj);
            }

            var selectElement = element.appendChild(document.createElement("select"));
            selectElement.id = 'selectedregion';
            selectElement.className = 'skr-select';
            selectElement.setAttribute("role", "listbox");
            for (let centre of optionList) {
                var option = document.createElement('option');
                option.text = centre.centreName;
                option.setAttribute("class", "optionGroup");
                option.setAttribute("optiontype", "centre");
                option.setAttribute("role", "option");
                option.value = centre.centreId;
                selectElement.add(option);
                for (let region of centre.regions) {
                    option = document.createElement('option');
                    option.text = region[1];
                    option.value = region[0];
                    option.setAttribute("class", "optionChild");
                    option.setAttribute("optiontype", "region");
                    option.setAttribute("role", "option");
                    selectElement.add(option);
                }
            }
            selectElement.addEventListener("change", () => {
                if (selectElement[selectElement.selectedIndex].getAttribute("optiontype") === "centre") {
                    chart.setAttribute('region', '');
                    chart.setAttribute('centre', selectElement.value);
                } else {
                    optionList.forEach((centre) => {
                        centre.regions.forEach((region) => {
                            if (region[0] == selectElement.value) {
                                chart.setAttribute('region', selectElement.value)
                                chart.setAttribute('centre', centre.centreId);
                            }
                        });
                    });
                }

            });
        });
    });
}
export function createAvailabilityRegionFilter(chart, element, type) {
    utils.loadJSONP("https://app.vantetider.se/spa/1.1/rest/filters/filterchoices/availabilityTrendfilter", true).then((data) => {
        let selectElement = element.appendChild(document.createElement("select"));
        selectElement.id = 'selectedregion';
        selectElement.className = 'skr-select';
        selectElement.setAttribute("role", "listbox");
        let regions = type == 'primary' ? data.regionsPrim : data.regionsSpeci;
        let option = document.createElement('option');
        option.text = "Riket";
        option.setAttribute("role", "option");
        option.value = '';
        selectElement.add(option);
        regions.forEach(region => {
            option = document.createElement('option');
            option.text = region.regionName;
            option.value = region.regionId;
            option.setAttribute("role", "option");
            selectElement.add(option);
        });
        selectElement.addEventListener("change", () => {
            chart.region = selectElement.value

        });

        if (type == 'regionsSpeci') {
            let serviceSelectElement = element.appendChild(document.createElement("select"));
            serviceSelectElement.id = 'selectedregion';
            serviceSelectElement.className = 'skr-select';
            serviceSelectElement.setAttribute("role", "listbox");
            data.serviceTypes.forEach(service => {
                let option = document.createElement('option');
                option.text = service.serviceTypeName;
                option.value = service.serviceTypeId;
                option.setAttribute("role", "option");
                serviceSelectElement.add(option);
            });

            serviceSelectElement.addEventListener("change", () => {
                chart.serviceid = serviceSelectElement.value;
            })
            chart.serviceid = serviceSelectElement.value;
        }
        chart.region = selectElement.value;
    });
}

